import httpClient from "../http/http-client";
import { IUserActionLog } from './user-action-log.model';

export default class UserActionLogService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', queryString?: string): Promise<{ count: number, rows: IUserActionLog[] }> {
    return this.http.get(`user-action-log?&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }
}
